import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-presentation-thumbprint',
  templateUrl: './presentation-thumbprint.component.html',
  styleUrls: ['./presentation-thumbprint.component.scss'],
  standalone: false,
})
export class PresentationThumbprintComponent {
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() public type!: PresentationThumbprintTypes;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @HostBinding('class.can-close') @Input() public canClose = true;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @HostBinding('class.open') @Input() public open = true;
  // TODO: Skipped for migration because:
  //  This input is used in combination with `@HostBinding` and migrating would
  //  break.
  @HostBinding('class.is-presenter') @Input() public isPresenter = false;

  @HostBinding('class.absolute')
  public get absolute(): boolean {
    return this.type === PresentationThumbprintTypes.ABSOLUTE;
  }

  @HostBinding('class.inline')
  public get inline(): boolean {
    return this.type === PresentationThumbprintTypes.INLINE;
  }

  public toggle(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    if (!this.canClose) {
      return;
    }
    this.open = !this.open;
  }
}
export enum PresentationThumbprintTypes {
  INLINE = 'inline',
  ABSOLUTE = 'absolute',
}
